const NormalInputFile = ({label, setterFun, isRequired, type, placeholder, value}) => {
  return (
    <div>
      <label
        htmlFor="startDate"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {label}{isRequired && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type || "text"}
        id="startDate"
        onChange={(e) => {
          setterFun(type === "file" ? e.target.files[0] : e.target.value);
        }}
        value={value}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
        placeholder={placeholder}
        required
      />
    </div>
  );
};

export default NormalInputFile;
